function log(s) {
  console.info('[react-ga]', s);
}

module.exports = log;



//////////////////
// WEBPACK FOOTER
// ../~/react-ga/src/utils/console/log.js
// module id = 501
// module chunks = 0